var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import Input from '@rad/components/inputs/input';
import ActionButton from '@rad/components/ui/action-button';
import { getTenantInvites, inviteToTenant, revokeTenantInvite, getOrganizationInvites, inviteToOrganization, revokeOrganizationInvite, } from '../../../../common/network/community';
import { getCommunityInvites, inviteToCommunity, revokeCommunityInvite } from '../../../../common/network/system';
import { useToast } from '../../../../contexts/toast';
const inviteMessages = {
    'added': 'That email already had an account and has been added.',
    'invited': 'Invitation sent. They join as soon as they create their account.',
    'already-invited': 'That email already has a pending invitation.',
};
/** Keyed on the scope kind so a new kind has to be handled here rather than falling through. */
const apiFor = (kind, id) => ({
    system: {
        list: () => getCommunityInvites(id),
        invite: (email) => inviteToCommunity(id, email),
        revoke: (inviteId) => revokeCommunityInvite(id, inviteId),
    },
    tenant: {
        list: getTenantInvites,
        invite: inviteToTenant,
        revoke: revokeTenantInvite,
    },
    member: {
        list: () => getOrganizationInvites(id),
        invite: (email) => inviteToOrganization(id, email),
        revoke: (inviteId) => revokeOrganizationInvite(id, inviteId),
    },
})[kind];
/** The scope's community id, flattened so hook dependencies stay primitives. */
const scopeId = (scope) => scope.kind === 'system' ? scope.communityId
    : scope.kind === 'member' ? scope.organizationId
        : '';
const MembersPanel = (props) => {
    var _a;
    const toast = useToast();
    const [invites, setInvites] = React.useState([]);
    const [email, setEmail] = React.useState('');
    const kind = props.scope.kind;
    const id = scopeId(props.scope);
    const api = React.useMemo(() => apiFor(kind, id), [kind, id]);
    const load = React.useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        const res = yield api.list();
        if (res)
            setInvites(res);
    }), [api]);
    React.useEffect(() => { load(); }, [load]);
    const handleInvite = () => __awaiter(void 0, void 0, void 0, function* () {
        const [success, res] = yield api.invite(email);
        load();
        if (success) {
            setEmail('');
            toast.success(inviteMessages[res.status]);
        }
        else {
            toast.error(res.map(e => e.message).join('\n'));
        }
    });
    const handleRevoke = (inviteId) => __awaiter(void 0, void 0, void 0, function* () {
        yield api.revoke(inviteId);
        load();
        toast.success('Invitation revoked');
    });
    const showAddForm = (_a = props.showAddForm) !== null && _a !== void 0 ? _a : true;
    return (_jsxs(_Fragment, { children: [showAddForm && _jsxs(_Fragment, { children: [_jsx("h6", { children: "Members" }), _jsx("p", { className: "text-muted small", children: "Enter an email address. If it already has a 76UNBOXED account the user joins immediately, otherwise an invitation is sent and they join as soon as they create their account." }), _jsxs("div", { className: "d-flex align-items-end gap-2 mb-4", children: [_jsx(Input, { label: "Email", kind: "email", className: "flex-grow-1", value: email, onChange: setEmail }), _jsx(ActionButton, { className: "btn btn-primary", onClick: handleInvite, disabled: !email, loadingText: "Sending...", children: "Add or invite" })] })] }), _jsx("h6", { className: "mb-2", children: "Pending invitations" }), invites.length === 0 ? (_jsx("p", { className: "text-muted small mb-0", children: "No pending invitations." })) : (_jsx("div", { className: "table-responsive", children: _jsxs("table", { className: "table table-sm table-hover mb-0", children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", { children: "Email" }), _jsx("th", { children: "Invited" }), _jsx("th", {})] }) }), _jsx("tbody", { children: invites.map(i => (_jsxs("tr", { children: [_jsx("td", { children: i.email }), _jsxs("td", { children: [_jsx("span", { className: "badge bg-warning-subtle text-warning-emphasis me-2", children: "Pending" }), _jsx("span", { className: "text-muted small", children: new Date(i.created).toLocaleDateString() })] }), _jsx("td", { className: "text-end", children: _jsx("button", { className: "btn btn-sm btn-link text-danger", onClick: () => handleRevoke(i.id), children: "Revoke" }) })] }, i.id))) })] }) }))] }));
};
export default MembersPanel;
